import React from 'react';
import { Linkedin, Github, Send, Instagram } from 'lucide-react';
import { SocialLink } from '../../components';
import './Footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div>
          © {new Date().getFullYear()} Yevhenii Volotskov. All rights reserved.
        </div>
        <nav className="social-links">
          <SocialLink
            href="https://www.linkedin.com/in/yevhenii-volotskov-101352230/"
            Icon={Linkedin}
          />
          <SocialLink href="https://github.com/m0thaf9cka/" Icon={Github} />
          <SocialLink href="https://t.me/m0thaf9cka/" Icon={Send} />
          <SocialLink
            href="https://www.instagram.com/m0thaf9cka/"
            Icon={Instagram}
          />
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
